import { createSelector } from 'reselect';
import { getProjectListState } from 'src/modules/project-list/selectors/getProjectListState';

export const getProjectListExport = createSelector([
  getProjectListState,
], (state) => state.export);
